/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GameTrackingHealthStatus } from './GameTrackingHealthStatus';
import {
    GameTrackingHealthStatusFromJSON,
    GameTrackingHealthStatusFromJSONTyped,
    GameTrackingHealthStatusToJSON,
    GameTrackingHealthStatusToJSONTyped,
} from './GameTrackingHealthStatus';
import type { HelpTicketGameHealthFailingFeature } from './HelpTicketGameHealthFailingFeature';
import {
    HelpTicketGameHealthFailingFeatureFromJSON,
    HelpTicketGameHealthFailingFeatureFromJSONTyped,
    HelpTicketGameHealthFailingFeatureToJSON,
    HelpTicketGameHealthFailingFeatureToJSONTyped,
} from './HelpTicketGameHealthFailingFeature';

/**
 * 
 * @export
 * @interface HelpTicketGameHealthContext
 */
export interface HelpTicketGameHealthContext {
    /**
     * 
     * @type {string}
     * @memberof HelpTicketGameHealthContext
     */
    gameId: string;
    /**
     * 
     * @type {GameTrackingHealthStatus}
     * @memberof HelpTicketGameHealthContext
     */
    status: GameTrackingHealthStatus;
    /**
     * 
     * @type {string}
     * @memberof HelpTicketGameHealthContext
     */
    statusReason?: string;
    /**
     * 
     * @type {number}
     * @memberof HelpTicketGameHealthContext
     */
    lastGepEventAt?: number;
    /**
     * 
     * @type {Array<HelpTicketGameHealthFailingFeature>}
     * @memberof HelpTicketGameHealthContext
     */
    topFailingFeatures: Array<HelpTicketGameHealthFailingFeature>;
}



/**
 * Check if a given object implements the HelpTicketGameHealthContext interface.
 */
export function instanceOfHelpTicketGameHealthContext(value: object): value is HelpTicketGameHealthContext {
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('topFailingFeatures' in value) || value['topFailingFeatures'] === undefined) return false;
    return true;
}

export function HelpTicketGameHealthContextFromJSON(json: any): HelpTicketGameHealthContext {
    return HelpTicketGameHealthContextFromJSONTyped(json, false);
}

export function HelpTicketGameHealthContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpTicketGameHealthContext {
    if (json == null) {
        return json;
    }
    return {
        
        'gameId': json['gameId'],
        'status': GameTrackingHealthStatusFromJSON(json['status']),
        'statusReason': json['statusReason'] == null ? undefined : json['statusReason'],
        'lastGepEventAt': json['lastGepEventAt'] == null ? undefined : json['lastGepEventAt'],
        'topFailingFeatures': ((json['topFailingFeatures'] as Array<any>).map(HelpTicketGameHealthFailingFeatureFromJSON)),
    };
}

export function HelpTicketGameHealthContextToJSON(json: any): HelpTicketGameHealthContext {
    return HelpTicketGameHealthContextToJSONTyped(json, false);
}

export function HelpTicketGameHealthContextToJSONTyped(value?: HelpTicketGameHealthContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameId': value['gameId'],
        'status': GameTrackingHealthStatusToJSON(value['status']),
        'statusReason': value['statusReason'],
        'lastGepEventAt': value['lastGepEventAt'],
        'topFailingFeatures': ((value['topFailingFeatures'] as Array<any>).map(HelpTicketGameHealthFailingFeatureToJSON)),
    };
}

